// extracted by mini-css-extract-plugin
export default {"VWSpace":"VWSpace_VWSpace__761jH"};